import React from 'react';

export const configure = () => {

}     

export const fire = (title,msg) => {
    console.log("[PushNotifier] web platform not supported")
}